import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';

import { LBRole, AppinfoService } from 'app/services/appinfo.service';
import { AppSettings } from 'app/app.settings';

export interface AddUserModalOutput {
	email: string;
	roleId: number;
	roleDesc: string;
}

@Component({
  selector: 'app-add-user-modal',
  templateUrl: './add-user-modal.component.html',
  styleUrls: ['../../config-sub-agencies/add-sub-agency-modal/add-sub-agency-modal.component.css', './add-user-modal.component.css']
})
export class AddUserModalComponent implements OnInit {

	public userEmail: string;
	public userRole: LBRole;

	public roles: LBRole[];
	constructor(
		public dialogRef: MatDialogRef<AddUserModalComponent>,
		private appinfoService: AppinfoService
	) { }

	public invite() {
		if (this.userEmail && this.userRole) {
			const data: AddUserModalOutput = {
				email: this.userEmail,
				roleId: this.userRole.rol_id,
				roleDesc: this.userRole.desc
			};
			this.dialogRef.close(data);
		}
	}
	ngOnInit() {
		this.roles = this.appinfoService.rolesByApp[AppSettings.appName];
		this.userRole = this.roles.find((r) => r.default) || this.roles[0];
	}

}
